<template>
    <div id="rechargeB" :style="{ 'height': 'calc(100% - ' + cHeight + 'px)' }">
        <div class="header">
            <div class="pkgName">当前套餐：{{ simInfo.pkgName ? simInfo.pkgName : '暂无套餐' }}</div>
            <div class="rl-wex">
                <div class="logo">
                    <img v-if="shebeiLogin == 1" src="./../../assets/shebei.jpg" alt="" />
                    <img v-else-if="simInfo.flowRatePool == '联通' || simInfo.flowRatePool == '乐语'"
                        src="./../../assets/cucc.png" alt="">
                    <img v-else-if="simInfo.flowRatePool == '电信'" src="./../../assets/ctcc.png" alt="">
                    <img v-else-if="simInfo.flowRatePool == '移动' || simInfo.flowRatePool == '移动接口'"
                        src="./../../assets/cmcc.png" alt="">
                    <img v-else :src="wxHeadImg" alt="微信头像">
                </div>
                <div class="skir">
                    <div class="el-status card-bg">已使用：{{ simInfo.pkgUseDay ? simInfo.pkgUseDay : '0' }}天</div>
                    <div class="el-status card-bg">剩余：{{ simInfo.pkgRemainDay ? simInfo.pkgRemainDay : '0' }}天</div>
                </div>
            </div>
            <div class="header-userInfo">
                <div class="el-status card-bg">流量套餐有效期至：{{ simInfo.endTimeString }}</div>
                <div class="iccid-line">设备编号{{ this.$store.state.recordLoginText }} </div>
            </div>
            <div class="notice">
                <van-swipe class="my-swipe" :autoplay="5000" vertical :loop="true" :height="40" :show-indicators="false">
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />南昌市178****2231的用户已购买720G-包年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />韶山市156****5143的用户已购买360G-包五年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />沈阳市151****3056的用户已购买240G-三年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />南宁市159****2968的用户已购买240G-包三年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />三明市166****2683的用户已购买240G-包五年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />深圳市186****2331的用户已购买144G-包五年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />福清市185****0260的用户已购买144G-包三年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />无锡市151****2932的用户已购买144G-包年套餐；</div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="jusaf"><van-icon name="volume-o" />济宁市138****0971的用户已购买240G-3年套餐</div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="packagePanel">
            <van-tabs @click="onClick">
                <van-tab :name="0">
                    <template #title>
                        <span>新春特惠套餐</span>
                    </template>

                    <van-row>
                        <template v-for="item in dataList1">
                            <van-col span="24" class="package" :key="item.id" @click="tabbarClick(item, '2')"
                                v-if="item.htmlType === 0">
                                <div class="package-name"
                                    :class="{ 'overlay-package': item.type == 11, 'label-defined-active': indexActive == item.id }">
                                    <div class="titleRemark" v-if="item.titleRemark">{{ item.titleRemark }}</div>
                                    <div class="redRemark">{{ item.redRemark }}</div>
                                    <div class="item-flex">
                                        <div class="price-title">{{ item.packageName }} </div>
                                        <div class="remark">{{ item.remark }}</div>
                                    </div>
                                    <div class="">
                                        <div class="package-price"><span style="color: #846FA2;font-size: 12px;">￥</span>
                                            {{ item.salePriceRmb - (toatl ? toatl : 0) }} <span
                                                style="color: #846FA2;font-size: 12px;">元</span></div>
                                        <div class="c-btn" @click="toRechange()">立即订购</div>
                                    </div>
                                    <div class="dialog" v-if="item.limitState === 1">
                                        <div class="deblocking" @click="clickDeblock(item.limitRemark)">点击解锁</div>
                                    </div>
                                </div>
                            </van-col>
                        </template>
                    </van-row>
                </van-tab>


                <van-tab :name="2">
                    <template #title>
                        <span class="tabimg">年包套餐</span>
                    </template>

                    <van-row>
                        <template v-for="item in dataList2">
                            <van-col span="24" class="package" :key="item.id" @click="tabbarClick(item, '3')"
                                v-if="item.htmlType === 2">
                                <div class="package-name"
                                    :class="{ 'overlay-package': item.type == 11, 'label-defined-active': indexActive == item.id }">
                                    <div class="titleRemark" v-if="item.titleRemark">{{ item.titleRemark }}</div>
                                    <div class="redRemark">{{ item.redRemark }}</div>
                                    <div class="item-flex">
                                        <div class="price-title">{{ item.packageName }} </div>
                                        <div class="remark">{{ item.remark }}</div>
                                    </div>
                                    <div class="">
                                        <div class="package-price"><span style="color: #846FA2;font-size: 12px;">￥</span>
                                            {{ item.salePriceRmb - (toatl ? toatl : 0) }} <span
                                                style="color: #846FA2;font-size: 12px;">元</span></div>
                                        <div class="c-btn" @click="toRechange()">立即订购</div>
                                    </div>
                                    <div class="dialog" v-if="item.limitState === 1">
                                        <div class="deblocking" @click="clickDeblock(item.limitRemark)">点击解锁</div>
                                    </div>
                                </div>
                            </van-col>
                        </template>
                    </van-row>
                </van-tab>


                <van-tab title="加油套餐" :name="1">
                    <van-row>
                        <template v-for="item in dataList">
                            <van-col span="24" class="package" :key="item.id" @click="tabbarClick(item, '1')"
                                v-if="item.htmlType === 1">
                                <div class="package-name"
                                    :class="{ 'overlay-package': item.type == 11, 'label-defined-active': indexActive == item.id }">
                                    <div class="titleRemark" v-if="item.titleRemark">{{ item.titleRemark }}</div>
                                    <div class="redRemark">{{ item.redRemark }}</div>
                                    <div class="item-flex">
                                        <div class="price-title">{{ item.packageName }} </div>
                                        <div class="remark">{{ item.remark }}</div>
                                    </div>
                                    <div class="">
                                        <div class="package-price"><span style="color: #846FA2;font-size: 12px;">￥</span>
                                            {{ item.salePriceRmb - (toatl ? toatl : 0) }} <span
                                                style="color: #846FA2;font-size: 12px;">元</span></div>
                                        <div class="c-btn" @click="toRechange()">立即订购</div>
                                    </div>
                                    <div class="dialog" v-if="item.limitState === 1">
                                        <div class="deblocking" @click="clickDeblock(item.limitRemark)">点击解锁</div>
                                    </div>
                                </div>
                            </van-col>
                        </template>
                    </van-row>
                </van-tab>
            </van-tabs>
        </div>
        <Checkstand :checkstandStyle="checkstandStyle" :dataToPay="dataToPay" :price="price" :typeStyle="typeStyle" />

        <div class="toRecharge" ref="toRecharge">
            <div class="quan" v-if="showjuan">
                <div class="w-zh">新客会员专享活动</div>
                <div class="z-icon" @click="lintTo"><span v-if="toatl">-￥{{ toatl }}</span></div>
            </div>
            <p class="detail" v-if="isNaturalMonth && thisCucc == 1" style="color: #FF6463;">每月22号后 请优先选择次月生效
            </p>
            <p class="detail" v-else-if="isNaturalMonth && isShowdetail">每月25号后 请优先选择次月生效
            </p>
            <div class="toRecharge-top" v-if="showMonthChoose || isNaturalMonth">
                <van-radio-group v-model="isNextMonth" class="radio-group-defined">
                    <div>
                        <van-radio name="0" checked-color="#FF6463">本月生效</van-radio>
                    </div>
                    <div>
                        <van-radio name="1" checked-color="#FF6463">次月生效</van-radio>
                    </div>
                </van-radio-group>
            </div>

            <div class="toRecharge-bottom" v-if="showjuan">
                <p><span>
                    </span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;"></span></p>
                <div class="toRechargeBtn" @click="toRechange()" v-if="limitState !== 1">
                    <div class="n-btn">订 购</div>
                </div>
                <div class="toRechargeBtn toRechargeBtn1" v-else>
                    <div class="n-btn">订 购</div>
                </div>
            </div>
            <div class="toRecharge-bottom" v-else>
                <p><span></span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;"></span></p>
                <div class="toRechargeBtn" @click="toRechange()" v-if="limitState !== 1">
                    <div class="n-btn">订 购</div>
                </div>
                <div class="toRechargeBtn toRechargeBtn1" v-else>
                    <div class="n-btn">订 购</div>
                </div>
            </div>

        </div>
        <van-dialog v-model="helpShow" title="点击解锁" :show-confirm-button="false">
            <div class="dialog-text">{{ limitRemark }}</div>
            <div class="btn-vis">
                <van-button type="primary" class="dialog-btn2" @click="closrDialog">取消</van-button>
                <van-button type="primary" class="dialog-btn3" @click="toBalanceRecharge">购买余额</van-button>
            </div>
        </van-dialog>

    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from 'vant';
import Checkstand from "@/components/Checkstand";
export default {
    components: { Checkstand },
    data() {
        return {
            cHeight: 0,
            dataList: [],
            dataList1: [],
            dataList2: [],

            shebeiLogin: localStorage.getItem("shebeiLogin"),
            indexActive: '',
            showjuan: true,//是否展示优惠卷
            toatl: 0,
            firstPrice: 0, //首单优惠金额 分
            simData: [],
            simInfo: {},
            nu: 0,
            itemInfo: {
                supplierTypeName: localStorage.getItem('supplierTypeName'),
                flowRate: '',
                salePriceRmb: ''
            },
            secondaryId: '',
            primaryId: '',
            isAdmin: '',
            globalIsAdmin: '',
            wxHeadImg: localStorage.getItem('wxHeadImg'),
            isNextMonth: '0',
            payType: 1,
            isNaturalMonth: false,
            showCheckstand: false,
            showMonthChoose: false,//判断是否显示本月次月

            //收银台
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay: {},
            price: 0,
            typeStyle: 1, //流量充值入口为1
            tabbar: '1',

            simData2: [],
            indexActive2: '',
            itemInfo2: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            },
            result: {},
            helpShow: false,
            isShowdetail: false,
            thisCucc: 0,
            limitRemark: '',
            limitState: '',
            amountObj: '',
        }
    },
    mounted() {
        this.cHeight = this.$refs.toRecharge.clientHeight
    },
    methods: {
        onClick(e) {
            if (e === 0) {
                if (this.dataList1.length > 0) {
                    this.tabbarClick(this.dataList1[0], '2')
                }
            } else if (e === 1) {
                if (this.dataList.length > 0) {
                    this.tabbarClick(this.dataList[0], '1')
                }
            } else if (e === 2) {
                if (this.dataList2.length > 0) {
                    this.tabbarClick(this.dataList2[0], '3')
                }
            }
        },
        clickDeblock(data) {
            this.limitRemark = data
            this.helpShow = true
        },
        closrDialog() {
            this.helpShow = false
        },
        toBalanceRecharge() {
            let fd = new FormData();
            fd.append("supplierId", sessionStorage.getItem("supplierCode"));
            wxRequest("sim/invent/state", fd, "post").then((res) => {
                if (res.data.code == 200) {
                    this.$router.push({
                        path: "/user/balanceRecharge",
                        query: {
                            iccid: this.$store.state.iccid,
                        },
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },
        lintTo() {
            this.$router.push({
                path: "/user/balanceRecharge",
                query: {
                    iccid: this.$store.state.iccid,
                },
            });
        },
        changeState(item, tabbar) {
            this.limitState = item.limitState
            this.indexActive = item.id;
            this.itemInfo = item;
            this.price = item.salePriceRmb;

            if (item.isAdmin != null &&
                item.isAdmin != undefined &&
                item.isAdmin == 1) {
                this.isAdmin = item.isAdmin;
            } else {
                this.isAdmin = this.globalIsAdmin;
            }
            this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type == 14 || item.type == 6 || item.type == 17 || item.type == 25 ? true : false;
            this.showMonthChoose = item.type == 2 || item.type == 10 || item.type == 14 || item.type == 6 || item.type == 17 || item.type == 25 ? true : false;
            this.isShowdetail = item.type == 2 || item.type == 10 ? true : false;


        },

        toRechange() {
            this.showCheckstand = false;
            var iccids = localStorage.getItem('iccid');
            var pop = {
                iccid: this.$store.state.iccid,
                pkgId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                isNextMonth: this.isNextMonth,
                price: this.price,
            }
            //判断是否是月卡
            if (this.isNaturalMonth || this.showMonthChoose == true) {
                pop.isNextMonth = this.isNextMonth;
            } else {
                pop.isNextMonth = '0';//万能卡
            }
            pop.pkgId = this.itemInfo.id
            wxRequest("sim/activity/timer", pop, "post").then(res => {
                var result = res.data.data;
                var data = {
                    iccid: this.$store.state.iccid,
                    soldPackageId: this.itemInfo.id,
                    isAdmin: this.isAdmin,
                    secondaryId: this.secondaryId,
                    primaryId: this.primaryId,
                    toatl: this.toatl,
                    salePriceRmb: this.itemInfo.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo.salePriceRmb - this.toatl * 1, 2, '.', ',') : 0,
                    mobile: this.mobile,
                    price: this.price,
                }
                if (res.data.code == 200) {
                    Dialog.confirm({
                        title: "套餐生效提醒",
                        message: "生效时间：" + res.data.data.start + "<br/>到期时间：" + res.data.data.end + "<br/>谨慎订购，误订不退款"
                    }).then(() => {
                        //判断是否是月卡
                        if (this.isNaturalMonth || this.showMonthChoose == true) {
                            data.isNextMonth = this.isNextMonth;
                        } else {
                            data.isNextMonth = '0';//万能卡
                        }

                        if (this.$store.state.source != false) {
                            data.source = this.$store.state.source;
                        } else {
                            data.source = 'xxgzh';
                        }

                        this.$store.state.showCheckstand = true;
                        this.$store.state.showCheckstandSource = 'flowRecharge';

                        this.dataToPay = data;

                    }).catch(() => { });
                } else {
                    //判断是否是月卡
                    if (this.isNaturalMonth || this.showMonthChoose == true) {
                        data.isNextMonth = this.isNextMonth;
                    } else {
                        data.isNextMonth = '0';//万能卡
                    }

                    if (this.$store.state.source != false) {
                        data.source = this.$store.state.source;
                    } else {
                        data.source = 'xxgzh';
                    }
                    this.$store.state.showCheckstandSource = 'flowRecharge';
                    this.$store.state.showCheckstand = true;

                    this.dataToPay = data;

                }
            })
        },

        //第n天后
        afterManyDays(manyDays) {
            let startTime = new Date();
            let startDate = new Date(startTime);
            startDate.setDate(startDate.getDate() + manyDays);
            return this.dateFormat('yyyy-MM-dd', startDate);
        },

        // 本月最后一天
        lastDayOfThisMonth() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0));
        },

        //下个月第一天
        firstDayOfNextMonth() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();

            let date2 = new Date(year, month + 1, 1)
            return this.dateFormat('yyyy-MM-dd', new Date(date2));
        },
        // 下个月最后一天
        lastDayOfNextMonth() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0));
        },

        changePayType(type) {
            this.payType = type;
        },

        //点击tabbar
        tabbarClick(data, index) {
            this.tabbar = index;
            this.price = data.salePriceRmb;
            data.total = 0
            data.secondaryId = ''
            data.primaryId = ''
            // if (index !== '1') {
            //     this.showjuan = true
            //     if (this.$route.query.total) {
            //         data.total = this.$route.query.total * 1
            //         data.secondaryId = this.$route.query.secondaryId
            //         data.primaryId = this.$route.query.primaryId
            //     } else {
            //         if (!!this.result.subJuan.price) {
            //             data.total = this.result.subJuan.price * 1
            //             if (this.result.subJuan.types === 1) {
            //                 data.secondaryId = this.result.subJuan.id
            //             } else {
            //                 data.primaryId = this.result.subJuan.id
            //             }
            //         }
            //     }
            // } else {
            //     this.showjuan = false
            // }
            this.changeState(data, index)
        }
    },
    created() {
        // this.$store.state.iccid = '89860476162040833588';
        // localStorage.setItem('iccid', '89860476162040833588')
        wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(res => {
            if (res.data.code == 200) {
                this.simInfo = res.data.data;
            }
        })
        var data = {
            iccid: this.$store.state.iccid
        }
        wxRequest("sim/user/soldPkg/next/pkg", data, "get").then(res => {
            var result = res.data.data;
            if (res.data.code == 200) {
                Dialog.alert({
                    title: '温馨提示',
                    message: res.data.message
                })
            }
        })
        wxRequest("sim/user/soldPkg", data, "get").then(res => {
            var result = res.data.data;
            this.result = res.data.data;
            if (res.data.code == 200 && result.list.length > 0) {
                this.endTime = result.endTime;
                let resultArray1 = [];
                let resultArray2 = [];
                for (let i = 0; i < result.list.length; i++) {
                    console.log('当前type' + result.list[i].type);
                    if (result.list[i].type == 17 || result.list[i].type == 14) {
                        this.thisCucc = 1
                    }
                }
                /**每月倒数第6天默认选中次月生效**/
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                var day = date.getDate();
                console.log('当前日期' + day);
                console.log('当前cucc' + this.thisCucc);
                var date2 = new Date(year, month + 1, 0)
                var endDay = date2.getDate();
                if (this.thisCucc == 0) {
                    day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
                } else {
                    if (day >= 21 && day <= 26) {
                        this.isNextMonth = '1'
                    } else {
                        this.isNextMonth = '0'
                    }
                }
                this.simData = result.list
                this.simData.sort((a, b) => b.sort - a.sort);
                this.isAdmin = result.isAdmin;
                this.globalIsAdmin = result.isAdmin;
                this.dataList = this.simData.filter(item => item.htmlType === 1)
                this.dataList1 = this.simData.filter(item => item.htmlType === 0)
                this.dataList2 = this.simData.filter(item => item.htmlType === 2)
                this.isNaturalMonth = this.dataList1[0].type == 2 || this.dataList1[0].type == 10 || this.dataList1[0].type == 14 || this.dataList1[0].type == 6
                    || this.dataList1[0].type == 25 || this.dataList1[0].type == 17 ? true : false;
                this.isShowdetail = this.dataList1[0].type == 2 || this.dataList1[0].type == 10 ? true : false;
                this.indexActive = this.dataList1[0].id;
                this.price = this.dataList1[0].salePriceRmb;
                this.itemInfo = this.dataList1[0];
                this.limitState = this.dataList1[0].limitState
                this.onlyYuPay = this.dataList1[0].onlyYuPay
                this.toatl = 0
                this.secondaryId = ''
                this.primaryId = ''
                if (this.$route.query.total) {
                    this.toatl = this.$route.query.total * 1 || 0
                    this.secondaryId = this.$route.query.secondaryId
                    this.primaryId = this.$route.query.primaryId
                } else {
                    this.toatl = result.subJuan.price * 1 || 0
                    if (result.subJuan.types === 1) {
                        this.secondaryId = result.subJuan.id
                    } else {
                        this.primaryId = result.subJuan.id
                    }
                }

            }
        })


    }
}
</script>
<style lang="less" scoped>
.tabimg {
    background: url('../../assets/a460a83.png')no-repeat left center;
    background-size: 21px 21px;
    padding-left: 25px;
}

#rechargeB {
    background: #fdddc8;
    height: calc(100% - 150px);
    overflow: auto;
    position: relative;

    .header {
        color: #fff;
        /* height:211px; */
        position: relative;
        width: 90%;
        margin: 20px auto;
        border-radius: 8px;
        background: url('../../assets/350520ce.jpg')no-repeat center;

        .pkgName {
            background-image: linear-gradient(-82deg, rgba(252, 246, 246, .39) 1%, #ecdab3);
            box-shadow: 0 0.05333rem 0.13333rem 0 rgba(0, 0, 0, .13);
            border-radius: 0 8px 0 8px;
            font-size: 12px;
            color: #80622e;
            position: absolute;
            right: 0;
            padding: 10px 14px;
        }

        .rl-wex {
            padding-top: 32px;
            display: flex;
            margin-left: 20px;
            align-items: center;

            .skir {
                color: #80622e;
                padding-left: 0px;
                font-size: 14px;
            }
        }

        .logo {
            width: 52px;
            height: 52px;
            margin-right: 10px;

            img {
                width: 52px;
                height: 52px;
                margin-bottom: 10px;
                border-radius: 35px;
                border: 2px solid #fff;
            }
        }

        .header-userInfo {
            padding-top: 18px;
            color: #80622e;
            margin-left: 20px;

            .iccid-line {
                display: inline-block;
                font-size: 12px;
                margin-top: 14px;
                margin-bottom: 5px;
            }

            .el-status {
                font-size: 0.75rem;
            }
        }

        .notice {
            background-image: url('../../assets/070ce05c.png');
            /* height:74px; */
            padding-top: 30px;
            background-size: 100% 100%;

            .my-swipe {
                height: 40px;
                color: #6a4526;
                text-align: center;

                .jusaf {
                    height: 40px;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    font-size: 12px;
                    display: flex;

                    .van-icon-volume-o {
                        margin-right: 8px;
                    }
                }
            }
        }
    }


    .packagePanel {
        width: 95%;
        margin: 0 auto;
        background: #fff;

        /* position: absolute;
		top:16%;
		left: 0;
		right:0;
		border-radius:0.625rem;
        */
        ::v-deep.van-tabs__content {
            margin-top: 10px;
        }

        .tabbar {
            display: flex;
            height: 60px;
            margin-bottom: 10px;

            p {
                flex: 1;
                height: inherit;
                text-align: center;
                font-size: 1.125rem;
                line-height: 60px;
                background: #F2F3F8;
                color: #94959A;
                font-weight: 600;
            }

            p:first-child {
                border-top-left-radius: 10px;
            }

            p:nth-child(2) {
                border-top-right-radius: 10px;
            }

            .activeTab {
                line-height: 60px;
                display: inline-block;
                color: #000000;
                background: #fff;
                height: 100%;
                display: inline-block;
                width: 100%;
            }
        }

        .package-title {
            padding: 10px 0px;
            color: #333;
            font-weight: bold;
        }

        .package {
            // flex:1;
            padding: 10px 5px;
            position: relative;

            // height:10rem;
            .label-defined {
                display: block;
                border-width: 14px 18px 14px 18px;
                border-style: solid;
                border-color: transparent;
                position: absolute;

                label {
                    position: absolute;
                    left: -14px;
                    top: -12px;
                    background: transparent;
                }
            }

            .package-name {
                flex-grow: 1;
                padding: 22px 10px;
                background: #fff;
                border-radius: 10px;
                position: relative;
                border: #EEEDED 1px solid;
                /* text-align: center; */
                align-items: center;
                display: flex;

                .item-flex {
                    width: 75%;
                }

                .price-title {
                    margin: 0 0 4px;
                    color: #846FA2;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;

                    p {
                        color: #999999;
                        font-size: 14px;
                    }
                }

                .redRemark {
                    position: absolute;
                    color: #fff;
                    background-image: linear-gradient(90deg, #FE6402 1%, #FE8F07);
                    font-size: 12px;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 10px;
                    padding: 4px 10px;
                    left: 40%;
                    top: 0;
                }

                .titleRemark {
                    position: absolute;
                    top: 0;
                    color: #fff;
                    left: 0;
                    padding: 4px 10px;
                    font-size: 12px;
                    background: red;
                    border-radius: 10px 0 10px 0;
                }

                .remark {
                    /* margin: 10px 0; */
                    color: #ccc;
                    line-height: 20px;
                    font-size: 12px;
                    font-weight: bold;
                }

                .dialog {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    background: rgba(0, 0, 0, .3);
                    border-radius: 10px;
                    display: flex;
                    justify-items: center;
                    align-items: center;

                    .deblocking {
                        width: 121px;
                        height: 38px;
                        background: linear-gradient(90deg, #FFA451 0%, #FF6463 100%);
                        border-radius: 19px;
                        font-size: 14px;
                        color: #fff;
                        text-align: center;
                        line-height: 38px;
                        margin: 0 auto;
                    }

                    .deblocking1 {
                        background: #ccc !important;
                        color: #000 !important;
                    }
                }
            }

            .label-defined-active {
                background: #FFF3EC url(../../assets/home/icon44.png) no-repeat right bottom;
                background-size: 35px 30px;
                border: #FF6463 1px solid;
            }

            .package-price {
                flex-grow: 0;
                color: #C34339;
                font-weight: 600;
                font-size: 1rem;
            }

            .package-price.overlay-package {
                border-color: #07c160;
                background: #07c160;
            }

            .c-btn {
                margin-top: 10px;
                background: linear-gradient(90deg, #625EF8 0%, #9052F8 100%);
                font-size: 12px;
                border-radius: 6px;
                padding: 8px 12px;
                cursor: pointer;
                color: #fff;
            }

        }

    }

    .quan {
        background: #F6F6F6;
        display: flex;
        align-items: center;
        height: 52px;
        margin-top: 4px;

        div {
            width: 50%;
        }

        .w-zh {
            color: #28292D;
            font-size: 18px;
            padding-left: 20px;
            line-height: 52px;
            font-weight: 600;
            height: 100%;
        }

        .z-icon {
            text-align: right;
            background: url('../../assets/hd/arrow.png')no-repeat 90% center;
            padding-right: 36px;
            color: #DE4160;
            font-weight: 600;
            font-size: 14px;
            height: 100%;
            line-height: 52px;
        }
    }

    .toRecharge {
        position: fixed;
        width: 100%;
        bottom: 0;
        font-size: 16px;
        background: #fff;

        .toRecharge-top {
            display: flex;

            .radio-group-defined {
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
                border-bottom: 1px solid #eee;
                height: 34px;

                /deep/.van-radio__icon--checked {
                    .van-icon-success {
                        background-color: #24BAC8 !important;
                        border-color: #24BAC8 !important;
                    }
                }

                /deep/.van-radio__label {
                    color: #666;
                    margin-left: 0px
                }

                div {
                    height: 20px;
                    margin-right: 15px;

                    .van-icon {
                        font-size: 12px;
                    }

                    &.van-radio__icon {
                        margin-right: 0;
                    }
                }

                span {
                    font-size: 0.75rem;
                }
            }

        }

        .detail {
            color: #96989D;
            font-size: 12px;
            padding-left: 20px;
            padding-top: 5px;
        }

        .toRecharge-bottom {
            display: flex;
            line-height: 46px;

            p {
                padding-right: 15px;
                flex-grow: 1;
                color: #999;
                background: #fff;
                font-size: 0.75rem;
                text-align: left;
                line-height: 46px;
                padding-left: 10px;

                span {
                    color: #FF6463;
                    font-weight: 600;
                    font-size: 1rem;
                    vertical-align: middle;
                }
            }

            .toRechargeBtn {
                padding: 0 60px;
                display: inline-block;
                line-height: 46px;
                flex-grow: 0;
                color: #fff;
                background: #FF6463;
            }

            .toRechargeBtn1 {
                color: #000;
                background: #ccc;
            }
        }

    }
}

.van-dialog {
    background: url('../../assets/home/iconBg.png') no-repeat center;
    width: 290px;
    height: 247px;
    background-size: 100%;

    ::v-deep .van-dialog__header {
        margin-top: 70px;
        color: #222;
        font-weight: 600;
        font-size: 19px;
    }

    .dialog-text {
        color: #94959A;
        font-size: 15px;
        padding-top: 11px;
        text-align: center;
        padding-bottom: 34px;
    }

    .btn-vis {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 90%;
        margin: auto;

        .dialog-btn2 {
            width: 120px;
            height: 47px;
            color: #666666;
            text-align: center;
            background: #F5F5F5 !important;
            border: 0 !important;
            border-radius: 7px;
            font-size: 16px;
            line-height: 47px;
        }

        .dialog-btn3 {
            width: 130px;
            height: 47px;
            border-radius: 7px;
            font-size: 16px;
            line-height: 47px;
            border: 0;
            color: #fff;
            background: linear-gradient(90deg, #FFA451 0%, #FF6140 100%);
            margin-left: 10px;
            text-align: center;
        }
    }
}

.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}

.shareit img {
    max-width: 100%;
}

.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}

.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}
</style>
<style>
.checkstand-defined .cancelPay .van-button--round {
    float: right;
}

.checkstand-defined .cancelInput .van-icon {
    margin: 10px 15px 10px 0;
    position: absolute;
    right: 0;
}

.checkstand-defined .passwordPanel .van-field__label {
    width: 60px;
}

.checkstand-defined .cancelInput .van-icon-close:before {
    font-size: 20px;
}

.checkstand-defined .van-icon::before {
    line-height: 30px;
}

.checkstand-defined .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.checkstand-defined .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
}

.checkstand-defined .passwordPanel .van-field__control {
    line-height: 24px;
}

.checkstand-defined .van-icon,
.checkstand-defined .van-icon::before {
    line-height: 62px;
}

.checkstand-defined .van-divider {
    padding: 0;
    margin: 0;
}
</style>